import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-light-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

const CampignQuoteLocked = () => (
  <Box
    alignItems="center"
    flexDirection="column"
    justifyContent="center"
    paddingY="xlarge"
    paddingX="large"
  >
    <Text color="orange" fontSize="xxlarge">
      <FontAwesomeIcon icon={faLock} />
    </Text>

    <Text
      color="bodyFontLightColor"
      fontSize="small"
      lineHeight="1.3"
      marginTop="large"
      textAlign="center"
    >
      A Finance Application is in progress for this quote and it cannot be modified.
    </Text>
  </Box>
)

export default CampignQuoteLocked
